import {Store} from 'vuex'
import axios from 'axios'
import VueI18n from 'vue-i18n'
import Vue from 'vue'

export default class ReferentielService {
  constructor(private store: Store<any>, private i18n: VueI18n) {
    this.store = store
    this.i18n = i18n
  }

  public loadReferentiel() {
    axios
      .get('api/referentiel')
      .then(({data}) => {
        this.store.commit('referentiel/setReferentiel', data)
      })
      .catch(() => {
        Vue.prototype.$edgToast.showError({
          title: this.i18n.t('erreur.titre'),
          message: this.i18n.t('erreur.messageRecuperationReferentiel')
        })
      })
  }

  public getVoiesCommune(idCommune) {
    this.store.commit('referentiel/setVoiesCommune', [])
    axios
      .get(`api/referentiel/${idCommune}`)
      .then(({data}) => {
        this.store.commit('referentiel/setVoiesCommune', data)
      })
      .catch(() => {
        Vue.prototype.$edgToast.showError({
          title: this.i18n.t('erreur.titre'),
          message: this.i18n.t('erreur.messageRecuperationVoiesCommune')
        })
      })
  }
}
